import React from "react";
import styled from "@emotion/styled";
import Image from "@components/item/Image";
import { useNavigate } from "react-router-dom";

const Container = styled.div({
  width: "25.2rem",
  display: "flex",
  flexDirection: "column",
  gap: "1.2rem",
});
const ImageWrapper = styled.div({
  width: "100%",
  height: "15.6rem",
  objectFit: "cover",
});

const DescWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  width: "25.2rem",
  gap: "0.8rem",
});

const Title = styled.h3(({ theme }) => ({
  color: theme.color.black,
  fontSize: "1.6rem",
  lineHeight: "1.6rem",
  width: "25.2rem",
  fontWeight: theme.fontWeight.semiBold,
}));

const Desc = styled.p(({ theme }) => ({
  color: theme.color.gray,
  fontSize: "1.4rem",
  lineHeight: "2rem",
  fontWeight: theme.fontWeight.regular,
}));

type Props = {
  id: number;
  title: string;
  desc?: string;
  src: string;
};

const HomeBrandCard = ({ title, desc, src, id }: Props) => {
  const navigate = useNavigate();

  const handleNavigateBrandDetailPage = (brandId: number) => {
    navigate(`/brand/${brandId}`);
  };
  return (
    <Container onClick={() => handleNavigateBrandDetailPage(id)}>
      <ImageWrapper>
        <Image src={src} width="100%" height="100%" />
      </ImageWrapper>

      <DescWrapper>
        <Title className="ellipsis-1">{title}</Title>
        <Desc className="ellipsis-2">{desc}</Desc>
      </DescWrapper>
    </Container>
  );
};

export default HomeBrandCard;
